import React from 'react';
import StandardDialog from '../StyledComponents/StandardDialog';
import {Grid, Typography} from '@mui/material';

export default function PendingApplicationPopup() {
  return (
    <StandardDialog open hideCloseButton>
      <Grid container direction="column" alignItems="center" mt={1.5}>
        <img
          src={'https://cdn.bidmii.com/media/web_assets/logo.webp'}
          alt="Bidmii Logo"
          style={{width: 100}}
        />

        <Typography variant="h6" lineHeight={1.3} textAlign="center" mt={3}>
          <b>
            Thanks for applying to be a<br />
            Bidmii Contractor!
          </b>
          <br />
          We're reviewing your application now, and you can expect an update
          within 48 hours.
        </Typography>
      </Grid>
    </StandardDialog>
  );
}
